__turbopack_context__.v({
  "amount": "LedgerRow-module__YZssGq__amount",
  "bar": "LedgerRow-module__YZssGq__bar",
  "deal": "LedgerRow-module__YZssGq__deal",
  "earned": "LedgerRow-module__YZssGq__earned",
  "figure": "LedgerRow-module__YZssGq__figure",
  "figureLabel": "LedgerRow-module__YZssGq__figureLabel",
  "muted": "LedgerRow-module__YZssGq__muted",
  "placement": "LedgerRow-module__YZssGq__placement",
  "product": "LedgerRow-module__YZssGq__product",
  "rank": "LedgerRow-module__YZssGq__rank",
  "row": "LedgerRow-module__YZssGq__row",
  "seller": "LedgerRow-module__YZssGq__seller",
  "track": "LedgerRow-module__YZssGq__track",
});
